<!-- TODO This component needs refactor, we can do it after migrating to vue 3 NP-2852-->
<template>
  <v-row
    v-if="list.length > 0 || (showSpecialOnEmptyList && special)"
    no-gutters
    class="pt-6 pb-6"
  >
    <v-col
      cols="12"
      sm="4"
      class="pr-0 pr-sm-6"
    >
      <v-row no-gutters>
        <v-col cols="12">
          <p class="mb-3 f-20 sz-primary-grey--text font-weight-medium">
            <v-icon
              v-if="icon"
              :size="25"
              color="szRed"
              class="mb-1 mr-1"
            >
              {{ icon }}
            </v-icon>
            {{ title }}
          </p>
        </v-col>
        <v-col
          v-if="special && $vuetify.display.smAndUp"
          cols="12"
          class="sz-primary-background pa-3 pa-sm-5 d-print-none"
        >
          <p
            v-if="list.length > 0"
            class="mb-0 f-16 font-weight-medium sz-primary-text--grey wrap-anywhere"
          >
            {{ specialRequirementsTitle }}:
          </p>
          <p class="ml-1 mb-0 f-16 font-weight-regular sz-primary-text--grey wrap-anywhere">
            {{ special }}
          </p>
        </v-col>
      </v-row>
    </v-col>
    <v-col
      v-if="list.length > 0"
      cols="12"
      sm="8"
      class="pl-0 pl-sm-6 mt-3 mt-sm-0"
    >
      <v-row no-gutters>
        <v-col
          v-for="(item, index) in list"
          :key="index"
          cols="6"
          class="needs-border-right pb-2 col-print-4"
        >
          <p
            v-if="getText(item)"
            class="text-indent ml-4 mb-0 f-16 sz-primary-grey--text font-weight-regular d-inline-block wrap-anywhere"
          >
            <span class="d-inline-block d-md-none d-print-none">•</span>
            <span
              class="d-none d-print-inline-block f-32 mr-1"
            >□ </span>
            {{ getText(item) }}
            <span
              v-if="other && index === 0"
              class="mb-0 f-16 sz-primary-grey--text font-weight-medium d-inline-block"
            >
              {{ other }}
            </span>
          </p>
          <p
            v-if="getGift(item)"
            class="text-indent ml-4 mb-0 f-16 sz-primary-grey--text font-weight-medium wrap-anywhere"
          >
            <span class="d-inline-block d-md-none d-print-none">•</span>
            <span
              class="d-none d-print-inline-block f-32 mr-1"
            >□ </span>
            {{ getGift(item).name }}:
            <span class="font-weight-regular">{{ getGift(item).text }}</span>
          </p>
          <div v-if="getClothing(item)">
            <div
              v-for="(personItem, index) in getClothing(item).item"
              :key="index"
            >
              <p class="text-indent ml-4 mb-0 f-16 sz-primary-grey--text font-weight-medium wrap-anywhere">
                <span class="d-inline-block d-md-none d-print-none">•</span>
                <span
                  class="d-none d-print-inline-block f-32 mr-1"
                >□ </span>
                {{ getClothing(item).name }}:
                <span class="font-weight-regular">
                  {{ itemType(personItem) }}
                </span>
              </p>
              <p class="ml-4 f-14 mb-0 sz-secondary-grey--text font-weight-regular wrap-anywhere">
                {{ $t('label.size') }}: {{ personItem.size }},
                <span v-if="personItem.note">{{ $t('label.comments') }}: {{ personItem.note }}</span>
              </p>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-col>
    <v-col
      v-if="special != null"
      cols="12"
      class="sz-primary-background pa-3 pa-sm-5 d-print-block d-flex d-sm-none"
    >
      <p
        v-if="list.length > 0"
        class="mb-0 f-16 font-weight-medium sz-primary-text--grey"
      >
        {{ $t('label.comments') }}:
      </p>
      <p class="mb-0 ml-5 f-16 font-weight-regular sz-primary-text--grey wrap-anywhere">
        {{ special }}
      </p>
    </v-col>
  </v-row>
</template>

<script>
import has from 'lodash/has';

export default {
    name: 'OtherNeedsBox',
    props: {
        title: {
            required: true,
            type: String
        },
        special: {
            type: String,
            default: null
        },
        showSpecialOnEmptyList: {
            type: Boolean,
            default: false
        },
        list: {
            required: true,
            type: Array
        },
        other: {
            default: null
        },
        icon: {
            default: null,
            type: String
        },
        specialRequirements: {
            default: true,
            type: Boolean
        }
    },
    computed: {
        specialRequirementsTitle () {
            return this.specialRequirements ? this.$t('label.specialRequirements') : this.$t('label.comments');
        }
    },
    methods: {
        itemType (item) {
            if (has(item, 'type')) {
                return item.category + ' (' + item.type + ')';
            }
            return item.category;
        },
        getText (item) {
            if (typeof item === 'string') {
                return item;
            }
            return null;
        },
        getGift (item) {
            if (typeof item === 'object') {
                if (has(item, 'gift')) {
                    return { text: item.gift, name: item.newName };
                }
            }
            return null;
        },
        getClothing (item) {
            if (typeof item === 'object') {
                if (has(item, 'chosenList')) {
                    return { item: item.chosenList, name: item.newName };
                }
            }
            return null;
        }
    }

};
</script>
